import { createSlice } from "@reduxjs/toolkit";
import { getFormLibrariesList } from "./getFormLibrariesList";
import { getFormDetails } from "./getFormDetails";
import { updateFormFieldsData } from "./updateFormFieldsData";
const initialState = {
  forms: {
    isLoading: false,
    data: [],
    success: false,
    errMsg: null,
  },
  formDetail: {
    isLoading: false,
    data: {},
    success: false,
    errMsg: null,
  },
  updateFields: {
    isLoading: false,
    data: {},
    success: false,
    errMsg: null,
  },
};
const DocsLibrary = createSlice({
  name: "DocsLibrary",
  initialState,
  extraReducers: {
    // get docs list api
    [getFormLibrariesList.pending]: (state) => {
      state.forms.isLoading = true;
      state.forms.errMsg = null;
    },
    [getFormLibrariesList.fulfilled]: (state, action) => {
      state.forms.isLoading = false;
      state.forms.data = action.payload;
    },
    [getFormLibrariesList.rejected]: (state, action) => {
      state.forms.isLoading = false;
      state.forms.errMsg = action.payload;
    },
    [getFormDetails.pending]: (state) => {
      state.formDetail.isLoading = true;
      state.formDetail.errMsg = null;
    },
    [getFormDetails.fulfilled]: (state, action) => {
      state.formDetail.isLoading = false;
      state.formDetail.data = action.payload?.data;
    },
    [getFormDetails.rejected]: (state, action) => {
      state.formDetail.isLoading = false;
      state.formDetail.errMsg = action.payload;
    },
    [updateFormFieldsData.pending]: (state) => {
      state.updateFields.isLoading = true;
      state.updateFields.errMsg = null;
    },
    [updateFormFieldsData.fulfilled]: (state, action) => {
      state.updateFields.isLoading = false;
      const updatedField = action.payload.data;

      const existingFields = state.formDetail.data.form_fields;
      const fieldsCollection =
        existingFields.find((f) => f.id === updatedField.id)
          ?.fields_collection || [];

      const updatedFields = [
        ...existingFields.filter((f) => f.id !== updatedField.id),
        {
          ...updatedField,
          fields_collection: fieldsCollection,
        },
      ];

      state.formDetail.data = {
        ...state.formDetail.data,
        form_fields: updatedFields,
      };
    },

    [updateFormFieldsData.rejected]: (state, action) => {
      state.updateFields.isLoading = false;
      state.updateFields.errMsg = action.payload;
    },
  },
});

export default DocsLibrary.reducer;
export * from "./getFormLibrariesList";
export * from "./getFormDetails";
export * from "./updateFormFieldsData";
